import { NAMESPACE } from 'react/api/actions/base';

const actions = {
  updateToolbarLayers: `${NAMESPACE}_ROUTE_DETAIL_UPDATE_TOOLBAR_LAYERS`,
  activeLayer: `${NAMESPACE}_ROUTE_DETAIL_ACTIVE_LAYER`,
  inactiveLayer: `${NAMESPACE}_ROUTE_DETAIL_INACTIVE_LAYER`,
  activateAllLayers: `${NAMESPACE}_ROUTE_DETAIL_ACTIVATE_ALL_LAYERS`,
  deactivateAllLayers: `${NAMESPACE}_ROUTE_DETAIL_DEACTIVATE_ALL_LAYERS`
};

const actionCreators = {
  updateToolbarLayers: (routeId, positionSources) => ({
    type: actions.updateToolbarLayers,
    payload: { routeId, positionSources }
  }),
  activeLayer: (routeId, positionSource) => ({
    type: actions.activeLayer,
    payload: { routeId, positionSource }
  }),
  inactiveLayer: (routeId, layerId) => ({
    type: actions.inactiveLayer,
    payload: { routeId, layerId }
  }),
  activateAllLayers: (routeId) => ({
    type: actions.activateAllLayers,
    payload: { routeId }
  }),
  deactivateAllLayers: (routeId) => ({
    type: actions.deactivateAllLayers,
    payload: { routeId }
  })
};

export default {
  actions,
  actionCreators
};
